
<ng-template #seeProductList let-modal>
  <p class="p-2 w-100" style="font-size: 1.4rem; font-weight: bold; text-align: center"><i
      class="fa-solid fa-handshake"></i> Similar Products</p>

  <div class="prods px-3">
    <ng-container *ngFor="let list of searchProds">
      <common-product-card-view (view)="goToProduct($event)" [list]="list" [isCommunityProduct]="true">
      </common-product-card-view>
    </ng-container>
  </div>
  <p *ngIf="searchProds.length < 1" class="p-3" style="text-align: center; color: var(--primary)"><i
      class="fas fa-heart-broken"></i> No products found for your search</p>
</ng-template>

<div class="types" [class.side]="!isOnMobile" [class.side-left]="!isOnMobile" [class.is-select-sub-cat]="isSelectSubCat"
  [style.--types-accent]="backgroundColor" *ngIf="!viewDesignScroll">
  <div class="types__one">
    <div class="header">
      {{ typeGroupingCustomNamesMap[1] ?? "Categories" }}
      <button class="t-btn p-2" *ngIf="isUserAnAdmin" style="color: var(--primary); font-size: medium"
        (click)="showEditCategoryModal()">
        <i class="fa fa-ellipsis-v"></i>
      </button>
    </div>
    <div class="type-btns">
      <ng-container *ngFor="let type of currentProductCategoryAvailableTypes">
        <div *ngIf="type.type == 1 && (isUserAnAdmin || showAllTypes || productTypes.has(type.id))">
          <input type="checkbox" *ngIf="isUserAnAdmin && editable" (change)="handleTypeAssignment($event, type)"
            [checked]="productTypes.has(type.id)" />
          <!-- <label [for]="type.id" class="btn btn-sm btn-outline-primary" (click)="toggleType(type)">
            
          </label> -->
          <button [class.electricity-effect]="type?.popular" class="btn btn-sm btn-outline-primary m-1 types-btn"
            (click)="toggleType(type)" [class.bright]="selectedTypeOneData?.id == type?.id">
            {{ type.name }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="types__two" *ngIf="typeTwoExists">
    <p class="header">{{ typeGroupingCustomNamesMap[2] ?? "Services" }}</p>
    <div class="type-btns">
      <ng-container *ngFor="let type of currentProductCategoryAvailableTypes">
        <div *ngIf="type.type == 2 && (isUserAnAdmin || showAllTypes || productTypes.has(type.id))">
          <input type="checkbox" *ngIf="isUserAnAdmin && editable" (change)="handleTypeAssignment($event, type)"
            [checked]="productTypes.has(type.id)" />
          <!-- <label [for]="'type-' + type.id" class="btn btn-sm btn-outline-primary" (click)="toggleType(type)">
            {{ type.name }}
          </label> -->
          <button class="btn btn-sm btn-outline-primary m-1 types-btn" (click)="toggleType(type)"
            [class.bright]="selectedTypeTwoData?.id == type?.id">
            {{ type.name }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- <div class="w-100 d-flex justify-content-center flex-column align-items-center">
    <button *ngIf="typeTwoExists || typeOneExists" class="btn m-1  mb-2 search-btn"
    (click)="searchUsingTypes()"><i class="fas fa-search"></i> Search</button>
    <button   class="btn m-1  mb-2 search-btn" *ngIf="productsToCompare?.length" (click)="openCompareProductsModal()"><i class="fa-solid fa-code-compare"></i>  Compare Products</button>
  </div> -->
</div>

<div [class.side]="!isOnMobile" [class.side-left]="!isOnMobile" [class.is-select-sub-cat]="isSelectSubCat"
  [style.--types-accent]="backgroundColor" *ngIf="viewDesignScroll && currentProductCategoryAvailableTypes?.length">
  <app-my-carousel-swiper *ngIf="typeOneExists || isUserAnAdmin" class="my-carousel-width-auto"
    [slide]="currentProductCategoryAvailableTypes" [config]="carouselWithNavOptions2">
    <div class="swiper-slide" *ngFor="let type of currentProductCategoryAvailableTypes">
      <ng-container *ngIf="type.type == 1 && (isUserAnAdmin || showAllTypes || productTypes.has(type.id))">
        <input type="checkbox" *ngIf="isUserAnAdmin && editable" (change)="handleTypeAssignment($event, type)"
          [checked]="productTypes.has(type.id)" />
        <button class="my-cate-carousel" (click)="toggleType(type)"
          [class.inactive-cate]="selectedTypeOneData?.id != type?.id">
          {{ type.name }}
        </button>
      </ng-container>
    </div>
  </app-my-carousel-swiper>
  <!-- <div class="grid-sub-cate" *ngIf="typeOneExists || isUserAnAdmin">
    <ng-container *ngFor="let type of currentProductCategoryAvailableTypes">
      <ng-container *ngIf="type.type == 1 && (isUserAnAdmin || showAllTypes || productTypes.has(type.id))">
        <input type="checkbox" *ngIf="isUserAnAdmin && editable" (change)="handleTypeAssignment($event, type)" [checked]="productTypes.has(type.id)" />
        <button class="cate" (click)="toggleType(type)" [class.inactive-cate]="selectedTypeOneData != type">
          {{ type.name }}
        </button>
      </ng-container>
    </ng-container>
  </div> -->
</div>